/*
 * Module for the Benefit Payroll Trial job criteria page
 */
rs.module("content/jobs/criteria/benefitpayrolltrial",

    [
        "controls/data/grid",
        "common/select-helper",
        "common/visibility",
        "controls/components/event-banner"
    ],

    function (gridModule, selectHelper, visibility, eventBanner) {

        var _executeReRunTrialSelectionChanged;
        var _executeParticipantBenefitSelectionChanged;

        // Initialize the page
        function initialize(
            jsSelectors,
            backendUrls,
            payrollTypes,
            modes,
            includedBenefits,
            columnIds,
            isInitial,
            searchControl,
            newBenefitGridLrsApi,
            rerunTrialGridLrsApi,
            participantBenefitGridLrsApi,
            includedbenefiteditableGridLrsApi)
        {
            // Unpack js selectors
            var criteria = $.js(jsSelectors.criteria);
            var hiddenPayrollBatchKey = criteria.js(jsSelectors.hiddenPayrollBatchKey);
            var hiddenManualBatchFlag = criteria.js(jsSelectors.hiddenManualBatchFlag);
            var payrollTypeSelect = criteria.js(jsSelectors.payrollTypeSelect);
            var modeRadioContainer = criteria.js(jsSelectors.modeRadioContainer);
            var trialBatchGridContainer = criteria.js(jsSelectors.trialBatchGridContainer);
            var trialBatchGridSpinner = criteria.js(jsSelectors.trialBatchGridSpinner);
            var monthSelect = criteria.js(jsSelectors.monthSelect);
            var yearInput = criteria.js(jsSelectors.yearInput);
            var manualBenefitsContainer = criteria.js(jsSelectors.manualBenefitsContainer);
            var includedBenefitsSelectContainer = criteria.js(jsSelectors.includedBenefitsSelectContainer);
            var includedBenefitsSelect = criteria.js(jsSelectors.includedBenefitsSelect);
            var newBenefitGridContainer = criteria.js(jsSelectors.newBenefitGridContainer);
            var newBenefitSpinner = criteria.js(jsSelectors.newBenefitSpinner);
            var editableGridContainer = criteria.js(jsSelectors.editableGridContainer);
            var benefitAddButton = criteria.js(jsSelectors.benefitAddButton);
            var benefitAddButtonErrorMessage = criteria.js(jsSelectors.benefitAddButtonErrorMessage);
            var gridErrorMessages = criteria.js(jsSelectors.gridErrorMessages, { multiple: true });
            var checkIssueDateInput = criteria.js(jsSelectors.checkIssueDateInput);
            var depositCreditDateInput = criteria.js(jsSelectors.depositCreditDateInput);
            var appliesToYearInput = criteria.js(jsSelectors.appliesToYearInput);
            var modalPopup = criteria.js(jsSelectors.modalPopup);
            var modalPopupAddButton = criteria.js(jsSelectors.modalPopupAddButton);
            var modalPopupCancelButton = criteria.js(jsSelectors.modalPopupCancelButton);
            var eligibleBenefitsSpinner = criteria.js(jsSelectors.eligibleBenefitsSpinner);

            // Get select helper(s);
            var monthSelectHelper = selectHelper.getHelper(monthSelect);
            var includedBenefitsSelectHelper = selectHelper.getHelper(includedBenefitsSelect);

            /* On-Load, we need to check if we are re-running a periodic manual trial, and if so, we need to retrieve the data to append as pending. */
            if (modeRadioContainer.find("input:checked").val() == modes.rerun && isInitial) {
                // Check if an item is selected.
                if (rerunTrialGridLrsApi.selectedValues > 0) {
                    if (payrollTypeSelect.val() == payrollTypes.periodic) {
                        var selectedPayrollBatchKey = parseInt(rerunTrialGridLrsApi.selectedValues);
                        loadReRunTrialBatchCriteria(selectedPayrollBatchKey);
                    }
                }
            }

            /* Hook up Event Listeners */

            // Register change events to their handlers
            payrollTypeSelect.change(resolveChildControlDisplay);
            modeRadioContainer.find("input").on("click", () => resolveChildControlDisplay());
            includedBenefitsSelect.change(includedBenefitSelectChanged);
            monthSelect.change(dateChanged);
            yearInput.change(dateChanged);

            // Hook up benefit search add button to display Modal Popup
            benefitAddButton.click(function () {
                if (monthSelect.val() != '' && yearInput.val() != '') {

                    // If the modal has a benefit selected, the add button should be available for the user.
                    var isBenefitSelected = participantBenefitGridLrsApi.selectedValues > 0;

                    eventBanner.removeAllMessages();
                    modalPopupAddButton.setDisabled(!isBenefitSelected);
                    modalPopup.modal('show');
                }
                else {
                    visibility.show(benefitAddButtonErrorMessage);
                }
            });

            // Listen for a person to be selected from the search control
            searchControl.onSelectionComplete(function (accountPartyKey) { getParticipantBenefitGrid(accountPartyKey); });

            // Listen for search selection to be removed
            searchControl.onSelectionCleared(function () {
                participantBenefitGridLrsApi.selectedValues = null;
                modalPopupAddButton.setDisabled();
                participantBenefitGridLrsApi.clearGridRows();
            });

            // Attempt to add the selected benefit to the grid.
            modalPopupAddButton.click(function () {

                if (participantBenefitGridLrsApi.selectedValues > 0) {

                    var selectedBenefitClaimPaymentKey = parseInt(participantBenefitGridLrsApi.selectedValues);

                    // Determine if the benefit is already in the grid
                    if (isBenefitNew(selectedBenefitClaimPaymentKey)) {

                        var selectedRow = participantBenefitGridLrsApi.selectedRows[0];
                        var newData = {
                            [columnIds.participantBenefit_benefitclaimpaymentkey]: selectedBenefitClaimPaymentKey,
                            [columnIds.participantBenefit_recipient]: selectedRow[columnIds.participantBenefit_recipient],
                            [columnIds.participantBenefit_benefitType]: selectedRow[columnIds.participantBenefit_benefitType],
                            [columnIds.participantBenefit_effectiveDate]: selectedRow[columnIds.participantBenefit_effectiveDate]
                        };
                        includedbenefiteditableGridLrsApi.addRow(newData, true);
                    }
                    else {
                        eventBanner.addErrorMessages("This benefit has already been added to the batch.");
                    }
                }

                searchControl.clear();
                modalPopup.modal('hide');

                // We do not want to submit the page on Modal Add button clicks.
                return false;
            });

            // Hide the Modal popup and clear the search once Close is clicked
            modalPopupCancelButton.click(function () {
                modalPopup.modal('hide');
                searchControl.clear();
                return false;
            });

            // Handle the included benefit drop down change event
            function includedBenefitSelectChanged() {

                // Clear errors
                eventBanner.removeAllMessages();
                clearCriteriaErrors();

                // Determine which grid to display.
                var includedBenefit = includedBenefitsSelect.val();
                if (includedBenefit == includedBenefits.newBenefits) {
                    visibility.hide(editableGridContainer);
                    getNewBenefitGridData();

                } else if (includedBenefit == includedBenefits.selectedBenefits) {
                    visibility.hide(newBenefitGridContainer);
                    visibility.show(editableGridContainer);
                }
            }

            // Handle participant benefit grid selection change event
            participantBenefitGridLrsApi.selectionChanged(function (values, rows) {
                // This handler fires when the grid is first rendered, but we don't want it to in our case
                if (_executeParticipantBenefitSelectionChanged) {
                    modalPopupAddButton.setDisabled(values.length == 0);
                }
                _executeParticipantBenefitSelectionChanged = true;
            });

            // Handle re-run trial grid selection change event
            rerunTrialGridLrsApi.selectionChanged(function (values, rows) {

                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // _executeReRunTrialSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeReRunTrialSelectionChanged) {

                    // Clear the included benefit editable grid on mode change.
                    clearCriteriaErrors();

                    if (values.length > 0) {
                        enableUserInputs(true);
                        hiddenPayrollBatchKey.val(values[0]);
                        loadReRunTrialBatchCriteria(values[0]);
                    }
                    else {
                        // User deselected, disable criteria and hide grids.
                        hiddenPayrollBatchKey.val('');
                        enableUserInputs(false);
                        hideManualBenefitsContainer();
                        hiddenManualBatchFlag.val(false);
                    }
                }

                _executeReRunTrialSelectionChanged = true;
            });

            // Handle mode changed event.
            function resolveChildControlDisplay() {

                // Clear errors
                eventBanner.removeAllMessages();
                clearCriteriaFields();
                clearCriteriaErrors();

                // Clear grid selections
                newBenefitGridLrsApi.selectedValues = null;
                includedbenefiteditableGridLrsApi.clearGridRows();

                // Determine which mode to populate for
                var mode = modeRadioContainer.find("input:checked").val();
                if (mode == modes.full) {

                    visibility.hide(trialBatchGridContainer);
                    hideManualBenefitsContainer();
                    enableUserInputs(true);
                    appliesToYearInput.prop('disabled', true);
                    hiddenManualBatchFlag.val(false);
                    hiddenPayrollBatchKey.val('');
                }
                else if (mode == modes.manual) {

                    visibility.hide(trialBatchGridContainer);
                    enableUserInputs(true);
                    appliesToYearInput.prop('disabled', false);
                    hiddenManualBatchFlag.val(false);
                    hiddenPayrollBatchKey.val('');

                    if (payrollTypeSelect.val() == payrollTypes.lumpSum) {
                        visibility.hide(includedBenefitsSelectContainer);
                        visibility.hide(editableGridContainer);
                        getNewBenefitGridData();
                    }
                    else if (payrollTypeSelect.val() == payrollTypes.periodic) {
                        visibility.show(manualBenefitsContainer);
                        visibility.show(includedBenefitsSelectContainer);
                        includedBenefitSelectChanged();
                    }
                }
                else if (mode == modes.rerun) {
                    visibility.hide(includedBenefitsSelectContainer);
                    includedBenefitsSelectHelper.setValue(includedBenefits.selectedBenefits);
                    getRerunTrialBatchesGridData();
                }
            }

            // Handle date changed event
            function dateChanged() {

                // Clear errors
                eventBanner.removeAllMessages();
                clearCriteriaErrors();

                var mode = modeRadioContainer.find("input:checked").val();

                // The date changing can only really effect manual or re-runs of manual.
                if (mode == modes.manual) {
                    var payrollType = payrollTypeSelect.val();

                    if (payrollType == payrollTypes.lumpSum) {
                        getNewBenefitGridData();
                    }
                    else if (payrollType == payrollTypes.periodic) {
                        includedBenefitSelectChanged();
                    }
                }
                else if (mode == modes.rerun) {

                    // If re-running a manual lump sum trial, display included benefits grid.
                    // For the manual flag, need to be sure it doesn't get typecasted to a string.
                    var isLumpSum = payrollTypeSelect.val() == payrollTypes.lumpSum;
                    var isManual = hiddenManualBatchFlag.normalizedBoolVal();

                    if (isLumpSum && isManual) {
                        getNewBenefitGridData();
                    }
                }
            }

            // Load the criteria associated with the given the payrollBatchKey
            function loadReRunTrialBatchCriteria(selectedPayrollBatchKey) {

                if (selectedPayrollBatchKey != '') {

                    // Clear criteria and show loading spinner
                    clearCriteriaFields();
                    trialBatchGridSpinner.show();

                    // Retrieve data
                    $.get(
                        backendUrls.getTrialBatchByBatchKey, { payrollBatchKey: selectedPayrollBatchKey },
                        function (data) {

                            // Set common criteria
                            monthSelectHelper.setValue(data.payrollMonth);
                            yearInput.val(data.payrollYear);
                            checkIssueDateInput.val(data.checkIssueDate ? new Date(data.checkIssueDate).toISODateString() : null);
                            depositCreditDateInput.val(data.depositCreditDate ? new Date(data.depositCreditDate).toISODateString() : null);
                            appliesToYearInput.val(data.appliesToYear);
                            appliesToYearInput.prop('disabled', !data.isManualFlag);
                            hiddenManualBatchFlag.val(data.isManualFlag);

                            if (data.isManualFlag) {

                                if (payrollTypeSelect.val() == payrollTypes.periodic) {
                                    // hide new benefit grid
                                    visibility.hide(newBenefitGridContainer);
                                    appendBenefitsInManualBatchToEditableGrid(selectedPayrollBatchKey);
                                }
                                else if (payrollTypeSelect.val() == payrollTypes.lumpSum) {
                                    visibility.hide(editableGridContainer);
                                    getNewBenefitGridData();
                                }
                            }
                            else {
                                hideManualBenefitsContainer();
                            }

                            trialBatchGridSpinner.hide();
                        }
                    );
                }
                else {
                    // User deselected, clear common criteria
                    enableUserInputs(false);
                }
            }

            // Get Selected Benefit grid Data
            function getRerunTrialBatchesGridData() {

                // Ensure Re-Run Grid is displayed
                visibility.show(trialBatchGridContainer);

                // Show loading spinner
                trialBatchGridSpinner.show();

                gridModule.update(
                    backendUrls.getTrialBatchesForReRunAsync,
                    {
                        payrollType: payrollTypeSelect.val()
                    },

                    rerunTrialGridLrsApi.agGridApi,

                    function done(gridUpdate) {

                        // Hide loading spinner.
                        trialBatchGridSpinner.hide();

                        if (gridUpdate.rowData.length > 0) {
                            // If rows are available, select first first row
                            rerunTrialGridLrsApi.selectFirstRow();
                        }
                        else {
                            // Else disable fields and hide grids.
                            hideManualBenefitsContainer();
                            enableUserInputs(false);
                            hiddenPayrollBatchKey.val('');
                            hiddenManualBatchFlag.val(false);
                        }
                    });
            }

            // Retrieve grid data for the new benefit grid
            function getNewBenefitGridData() {

                // clear selection
                newBenefitGridLrsApi.selectedValues = null;

                // Ensure grid is displayed
                visibility.show(manualBenefitsContainer);
                visibility.show(newBenefitGridContainer);

                // Show loading spinner
                newBenefitSpinner.show();

                // Check if we need to pre-select any items
                var selectedPayrollBatchKey = null;
                if (modeRadioContainer.find("input:checked").val() == modes.rerun) {
                    selectedPayrollBatchKey = parseInt(rerunTrialGridLrsApi.selectedValues);
                }

                // Retrieve grid
                gridModule.update(
                    backendUrls.getIncludedBenefitGridAsync,
                    {
                        month: monthSelect.val(),
                        year: yearInput.val(),
                        payrollBatchKey: selectedPayrollBatchKey,
                        payrollType: payrollTypeSelect.val()
                    },
                    newBenefitGridLrsApi.agGridApi,
                    function done(gridUpdate) {
                    }).fail(function (jqXHR, textStatus, errorThrown) {
                        newBenefitGridLrsApi.clearGridRows();
                    }).always(function () {
                        newBenefitSpinner.hide();
                    });
            }

            // Retrieve the benefits already in the Manual Benefit Payroll Trial and append them to the grid.
            function appendBenefitsInManualBatchToEditableGrid(payrollBatchKey) {

                // Clear grid items
                includedbenefiteditableGridLrsApi.clearGridRows();

                // Ensure that grid is displayed
                visibility.show(manualBenefitsContainer);
                visibility.show(editableGridContainer);

                // Retrieve grid items as appending
                gridModule.update(
                    backendUrls.getBenefitsInManualBatchAsync,
                    {
                        payrollMonth: monthSelect.val(),
                        payrollYear: yearInput.val(),
                        payrollBatchKey: payrollBatchKey
                    },

                    includedbenefiteditableGridLrsApi.agGridApi,

                    function done(gridUpdate) {

                    },
                    { appendAsPending: true }
                );
            }

            // Retrieve participant's benefits grid for modal popup.
            function getParticipantBenefitGrid(accountPartykey) {

                // Show loading spinner
                eligibleBenefitsSpinner.show();

                gridModule.update(
                    backendUrls.getEligibleBenefitsForParticipantAsync,
                    {
                        month: monthSelect.val(),
                        year: yearInput.val(),
                        accountPartyKey: accountPartykey
                    },

                    participantBenefitGridLrsApi.agGridApi,

                    function done(gridUpdate) {
                        // Hide spinner
                        eligibleBenefitsSpinner.hide();

                        // Determine if add button is enabled.
                        modalPopupAddButton.setDisabled(gridUpdate.rowData.length == 0);

                        // if only one benefit in grid, select it.
                        if (gridUpdate.rowData.length == 1) {
                            participantBenefitGridLrsApi.selectFirstRow();
                        }
                    })
                    .done(function (_, __, xhr) {
                        if (xhr.rsMessages) {
                            modalPopup.modal('hide');
                        }

                    })
                    .fail(function (_, __, xhr) {
                        if (xhr.rsMessages) {
                            modalPopup.modal('hide');
                        }
                    });
            }

            // Determine if the payee's benefit is not already in the grid.
            function isBenefitNew(benefitClaimPaymentKey) {
                var rows = includedbenefiteditableGridLrsApi.getChanges();
                var matchNotFound = true;
                if (rows.length > 0) {
                    rows.forEach(row => {
                        if (benefitClaimPaymentKey == row.newData[columnIds.participantBenefit_benefitclaimpaymentkey]) {
                            matchNotFound = false;
                        }
                    });
                }
                return matchNotFound;
            }

            // Hide all containers to that we may better control what to reveal.
            function hideManualBenefitsContainer() {
                [
                    manualBenefitsContainer,
                    includedBenefitsSelectContainer,
                    newBenefitGridContainer,
                    editableGridContainer
                ].forEach((input) => visibility.hide(input));
            }

            // Boolean to toggle the job criteria. Either enabled, or disabled and cleared.
            function enableUserInputs(enabled) {
                if (enabled) {
                    monthSelectHelper.setDisabled(false);
                    monthSelect.clearErrors();
                    [
                        yearInput,
                        checkIssueDateInput,
                        depositCreditDateInput
                    ].forEach((input) => input.prop('disabled', false))
                }
                else {
                    monthSelectHelper.setDisabled(true);
                    monthSelectHelper.setValue("");
                    monthSelect.clearErrors();
                    [
                        yearInput,
                        checkIssueDateInput,
                        depositCreditDateInput,
                        appliesToYearInput
                    ].forEach((input) => input.clearErrors().val("").prop('disabled', true))
                }
            }

            // Clear user input and errors
            function clearCriteriaFields() {
                // User deselected, clear common criteria
                [
                    yearInput,
                    checkIssueDateInput,
                    depositCreditDateInput,
                    appliesToYearInput
                ].forEach((input) => input.clearErrors().val(''));
                monthSelect.clearErrors();
                monthSelectHelper.setValue('');
            }

            // Clear the field-level errors
            function clearCriteriaErrors() {

                // Clear grid error messages.
                gridErrorMessages.each(function (grid) {
                    $(this).text('');
                });

                // hide no date selected error message
                visibility.hide(benefitAddButtonErrorMessage);

                // User deselected, clear common criteria
                [
                    yearInput,
                    checkIssueDateInput,
                    depositCreditDateInput,
                    appliesToYearInput
                ].forEach((input) => input.clearErrors());
                monthSelect.clearErrors();
            }
        }

        var exports = {
            initialize: initialize,
        };

        return exports;
    }
);